// extracted by mini-css-extract-plugin
module.exports = {"mediaButtonIcon":"_1aZkp","unmuted":"YXySM","muted":"_3C9vx","volumeBtn":"_2fnFg","volumeScale":"_3Zmv-","on":"_316TM","colorBlock":"_14IX2","off":"_20hqt","colorBlank":"_3B6pl"};